import { useSelector } from "react-redux";
import SC from "./style.js";
import searchicon from "@assets/icons/searchicon.png";
import { isAdmin } from "utils/helper/index.js";

const NoProject = () => {
  const accessLevel = useSelector(
    (state) => state?.authdata?.data?.userType || 0
  );

  return (
    <SC.Noproject>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={searchicon} alt="" height="30px" width="30px" />
        {isAdmin(accessLevel) ? (
          <h1 style={{ marginLeft: "10px" }}>No Projects Created</h1>
        ) : (
          <h1 style={{ marginLeft: "10px" }}>No Projects Assigned</h1>
        )}
      </div>
      {isAdmin(accessLevel) ? (
        <>
          <p
            style={{
              width: "550px",
              marginTop: "-10px",
              textAlign: "center",
              paddingBlock: "0px",
              marginBlock: "0px",
            }}
          >
            It seems that you don't have any projects created at the moment.
          </p>
          <p style={{ paddingBlock: "0px", marginBlock: "0px" }}>
            Please Create your first Project
          </p>
        </>
      ) : (
        <p style={{ width: "550px", marginTop: "-10px", textAlign: "center" }}>
          It seems that you don't have any projects assigned at the
          moment.&nbsp; &nbsp; &nbsp; Please contact the administrator to get
          access to the projects.
        </p>
      )}
    </SC.Noproject>
  );
};

export default NoProject;
